// === Task 27a === Visual templates / presets library.
// Each preset is a small workflow PROPOSAL: { variables, triggers } that gets
// merged into the section's workflow as ONE undo step (via MERGE_WORKFLOW_PROPOSAL).
//
// Authors use these as starting points for common L&D patterns. Each preset
// references the currently-selected interactive plugin box id (passed in at
// apply time) so the triggers wire to the right plugin.

let _uid = 0;
const nextId = (prefix = "t") =>
  `${prefix}_${(_uid++).toString(36)}_${Math.random().toString(36).slice(2, 6)}`;

function makePreset(id, name, description, applyFn) {
  return { id, name, description, apply: applyFn };
}

export const PRESETS = [
  makePreset(
    "quiz-with-feedback",
    { en: "Quiz with feedback", tr: "Geribildirimli sınav" },
    { en: "MCQ + Right/Try again text + retry", tr: "MCQ + Doğru/Tekrar dene + tekrar" },
    ({ pluginBoxId }) => ({
      variables: [],
      triggers: [
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.correct",
          actions: [
            { kind: "showText", text: { en: "Right!", tr: "Doğru!" }, durationMs: 1200 },
            { kind: "resume" },
          ],
        },
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.wrong",
          actions: [
            { kind: "showText", text: { en: "Try again", tr: "Tekrar dene" }, durationMs: 1200 },
            { kind: "replayItem", pluginBoxId },
          ],
        },
      ],
    })
  ),

  makePreset(
    "decision-branch",
    { en: "Decision branch", tr: "Karar dalı" },
    { en: "Yes/No → next vs remediation", tr: "Evet/Hayır → ilerle ya da iyileştir" },
    ({ pluginBoxId }) => ({
      variables: [],
      triggers: [
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.correct",
          actions: [{ kind: "resume" }],
        },
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.wrong",
          actions: [{ kind: "jumpScene", target: "TBD_remediation" }],
        },
      ],
    })
  ),

  makePreset(
    "card-flip-reveal",
    { en: "Card flip reveal", tr: "Kart çevirme keşfi" },
    { en: "Informational FlipCard, no rule", tr: "Bilgilendirici FlipCard, kural yok" },
    ({ pluginBoxId }) => ({
      variables: [],
      triggers: [
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onFlip",
          actions: [{ kind: "wait", ms: 500 }],
        },
      ],
    })
  ),

  makePreset(
    "wrong-counter-3-strikes",
    { en: "3-strike remediation", tr: "3 hatada iyileştirme" },
    {
      en: "Count wrongs, after 3 → remediation",
      tr: "Yanlışları say, 3'te → iyileştirme",
    },
    ({ pluginBoxId }) => ({
      variables: [{ id: "wrongCount", type: "number", initial: 0, scope: "session" }],
      triggers: [
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.correct",
          actions: [{ kind: "resume" }],
        },
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.wrong",
          actions: [
            { kind: "setVar", varId: "wrongCount", op: "add", value: 1 },
            {
              kind: "branch",
              condition: "wrongCount >= 3",
              whenTrue: [{ kind: "jumpScene", target: "TBD_remediation" }],
              whenFalse: [{ kind: "replayItem", pluginBoxId }],
            },
          ],
        },
      ],
    })
  ),

  makePreset(
    "score-aggregator-section-end",
    { en: "Section-end scoring", tr: "Bölüm sonu puanlama" },
    { en: "Aggregate score + emit", tr: "Puanı topla + yayınla" },
    ({ pluginBoxId }) => ({
      variables: [{ id: "score", type: "number", initial: 0, scope: "session" }],
      triggers: [
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onAnswer.correct",
          actions: [{ kind: "setVar", varId: "score", op: "add", value: 10 }, { kind: "resume" }],
        },
      ],
    })
  ),

  makePreset(
    "replay-then-quiz",
    { en: "Hint then quiz", tr: "İpucu sonra sınav" },
    { en: "Show hint → wait → ask question", tr: "İpucu göster → bekle → soru sor" },
    ({ pluginBoxId }) => ({
      variables: [],
      triggers: [
        {
          id: nextId(),
          sceneId: "*",
          pluginBoxId,
          on: "onShow",
          actions: [
            {
              kind: "showText",
              text: { en: "Read carefully", tr: "Dikkatli oku" },
              durationMs: 2000,
            },
            { kind: "wait", ms: 200 },
          ],
        },
      ],
    })
  ),
];

export function getPreset(id) {
  return PRESETS.find((p) => p.id === id);
}
// === /Task 27a ===
